import React from "react";
import SvgIcon from "../../../../../assets/icons/SvgIcon";
import { LOCAL_STORAGE_KEYS } from "../../../../../constants";
import { getProjectBuildingPrice, setLocalStorage } from "../../../../../utils";
import ClientEnquirySection from "./ClientEnquirySection";
import { getSearchPropertyDetail } from "../../../../../redux/actions/customer/searchAction";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../../../../redux/store";
import { useDispatch } from "react-redux";

interface ProjectHeaderSectionProps {
  projectData: any;
  alreadyRequestTour: any;
  setAlreadyRequestTour: any;
}

const ProjectHeaderSection: React.FC<ProjectHeaderSectionProps> = ({
  projectData,
  alreadyRequestTour,
  setAlreadyRequestTour,
}) => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const isSoldOut =
    projectData?.total_sold_units >=
    (projectData?.total_flats || projectData?.total_houses);

  return (
    <div className="md:px-6 md:py-6">
      <div
        className={`header-section relative flex justify-between items-center gap-6 w-full flex-col lg:flex-row ${isSoldOut ? "flex-col md:flex-row" : ""}`}
      >
        <div className="flex-1">
          <div className="flex justify-start items-center gap-2 py-4">
            <SvgIcon iconName="real-estate-icon" className="size-6" />
            <h2 className="flex flex-wrap gap-2 font-bold text-black text-xl xs:text-2xl">
              <span>{projectData?.name}</span>
              {getProjectBuildingPrice(projectData)?.length ? (
                <span className="text-dark-cyan text-base/[1.8rem] xs:text-xl">
                  {`(${getProjectBuildingPrice(projectData)})*`}
                </span>
              ) : null}
            </h2>
          </div>

          {projectData?.groups?.length ? (
            <div className="flex flex-wrap gap-1 xs:gap-x-2 font-normal text-black xs:text-lg">
              By
              {projectData.groups.map((group: any) => (
                <button
                  key={group?._id}
                  className="bg-gray-400/20 px-2 rounded text-blue-500 cursor-pointer max-xs:text-base"
                  onClick={() => {
                    const data = {
                      group_id: group?._id,
                      page: 1,
                      limit: 50,
                      startPrice: 0,
                      endPrice: 0,
                    };
                    navigate(`/search?page=1&group_id=${group?._id}`);
                    setLocalStorage(LOCAL_STORAGE_KEYS.FILTER, {
                      group: {
                        label: group?.name,
                        value: group?._id,
                      },
                    });
                    dispatch(getSearchPropertyDetail(data));
                  }}
                >
                  {group.name}
                </button>
              ))}
            </div>
          ) : null}
        </div>
        <div
          className={`flex justify-between items-center gap-4 w-fit action-buttons`}
        >
          {isSoldOut ? (
            <div className="mx-5 mr-20 lg:mr-5 min-w-max font-bold text-red-600 text-2xl">
              Sold Out
            </div>
          ) : null}
          <div className="enquiry-tour-section">
            {projectData && (
              <ClientEnquirySection
                className={`flex flex-col sm:flex-row justify-between items-center xs:gap-6 gap-2`}
                projectData={projectData}
                alreadyRequestTour={alreadyRequestTour}
                setAlreadyRequestTour={setAlreadyRequestTour}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectHeaderSection;
